interface IPublicViewSettingsBasePayload {
  pluginModule: string;
  moduleWidgetType: string;
}

export interface IPublicViewSettingsRequestPayload extends IPublicViewSettingsBasePayload { }

export interface IPublicViewSettingsResponsePayload<TSettings extends object = object> extends IPublicViewSettingsBasePayload {
  defaultSettings: TSettings;
}

declare module 'core-client/api' {
  interface BroadcastPayloads {
    readonly 'core_plugin:publicViewSettings:request': IPublicViewSettingsRequestPayload;
    readonly 'core_plugin:publicViewSettings:response': IPublicViewSettingsResponsePayload;
  }
  interface ActionPayloads {
    readonly 'core_plugin:userPreferences:open': {
      /** Tab id to preselect, e.g. USER_PREFERENCES_TAB.AUDIO. */
      tabId?: string;
      /** Opaque parameters handed to that tab's sections. */
      sectionParams?: Readonly<Record<string, unknown>>;
    };
  }
}

export const CorePluginBroadcasts = {
  PUBLIC_VIEW_SETTINGS: {
    REQUEST: 'core_plugin:publicViewSettings:request' as const,
    RESPONSE: 'core_plugin:publicViewSettings:response' as const,
  }
} as const;

export const CorePluginActions = {
  UserPreferences: {
    OPEN: 'core_plugin:userPreferences:open' as const,
  },
} as const;